import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { AllocationRulesContext } from '../../context';
import { selectedTagForFilterSet, getUpdatedCollectionFilter } from '../../rule-helper';
import { Pill } from 'ui-components/components/pill';
import messages from '../../messages';
import style from './style.module.less';

const TagMenu = ({ filterId }) => {
  const { sellerTags, filterSets, persistUpdatedFilterSet } = useContext(AllocationRulesContext);
  const filterSet = filterSets[filterId];
  const selectedTag = selectedTagForFilterSet(filterSet, sellerTags);

  const updateFilterSet = useCallback(
    (selectedTagId) => {
      persistUpdatedFilterSet(getUpdatedCollectionFilter(selectedTagId, filterSet));
    },
    [persistUpdatedFilterSet, filterSet],
  );

  return (
    <div className={style['tag-menu-wrapper']}>
      <FormattedMessage {...messages.allocationStrategiesTagName} />
      <DropdownMenu className={style['tag-menu']}>
        <DropdownMenuToggler>
          <Pill className={style.pill} collapsed color={selectedTag.hexColor} label={selectedTag.name} />
          <span className={style['tag-name']}>{selectedTag.name}</span>
        </DropdownMenuToggler>
        {sellerTags.map((tag) => {
          return (
            <DropdownMenuItem key={tag.tagId} onClick={() => updateFilterSet(tag.tagId)}>
              <Pill className={style.pill} collapsed color={tag.hexColor} label={tag.name} />
              <span className={style['tag-name']}>{tag.name}</span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenu>
    </div>
  );
};

TagMenu.propTypes = {
  filterId: PropTypes.number.isRequired,
};

export default TagMenu;
